<div id="learnosity_assess"></div>

<campus-freshworks [eduContent]="eduContent"></campus-freshworks>
